import React from 'react';
import { X } from 'lucide-react';

interface QRScanSuccessModalProps {
  isOpen: boolean;
  scannedId?: string;
  onClose: () => void;
}

export function QRScanSuccessModal({ isOpen, scannedId, onClose }: QRScanSuccessModalProps) {
  if (!isOpen) return null;

  console.log('[QR Scan Success Modal] Displaying modal with scanned ID:', scannedId);

  return (
    <div className="fixed inset-0 z-[250] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />

      <div className="relative bg-gradient-to-br from-[#1C1C1C] to-[#888888] shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden text-white ">
        <div className="p-6 border-b border-white/10 flex items-center justify-between">
          <h2 className="text-2xl font-playfair text-white">Free Recipe</h2>
          <button
            onClick={onClose}
            className="text-white/70 hover:text-white transition-colors p-1 hover:bg-white/10 rounded-full"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="p-6 overflow-y-auto" style={{ maxHeight: 'calc(90vh - 80px)' }}>
          <p className="text-sm text-white/70 mb-1 italic">To thank you for your support, here is one of our secrete recipe!</p>
          <p className="text-sm text-white/70 mb-8 italic">Make sure you write it down!</p>
          <h3 className="text-2xl font-playfair mb-4 text-white">Chestnut Bread</h3>
          {scannedId && (
            <div className="mb-6 p-4 bg-amber-500/10 border border-amber-500/20 rounded-xl">
              <p className="text-sm text-white/70 mb-1">QR Code Scanned:</p>
              <p className="text-lg font-semibold text-amber-400">{scannedId}</p>
            </div>
          )}

          <div className="space-y-6 text-left">
            <div className="bg-white/5 border border-white/10 rounded-xl p-5">
              <h4 className="text-lg font-semibold mb-3 text-amber-400">Ingredients</h4>
              <ul className="space-y-2 text-white/90">
                <li>• T65 Flour: 800g (50%)</li>
                <li>• Chestnut Flour: 200g (20%)</li>
                <li>• Salt: 18g</li>
                <li>• Water: 650g to 680g (65-68%)</li>
                <li>• Sourdough Starter: 300g (30%)</li>
                <li>• Chestnut Pieces: 200g (20%)</li>
              </ul>
            </div>

            <div className="bg-white/5 border border-white/10 rounded-xl p-5">
              <h4 className="text-lg font-semibold mb-3 text-amber-400">Fermentation</h4>
              <p className="text-white/90">Direct: 6 to 7 hours at room temperature (18-20°C)</p>
            </div>

            <div className="bg-white/5 border border-white/10 rounded-xl p-5">
              <h4 className="text-lg font-semibold mb-3 text-amber-400">Preparation</h4>
              <div className="space-y-3 text-white/90">
                <p><strong className="text-white">Hand method:</strong> Mix all the ingredients except the chestnut pieces and knead for 3 to 5 minutes until a smooth dough is obtained. This kneading marks the beginning of fermentation.</p>
                <p>Let the dough rest for 20 minutes, then incorporate the chestnut pieces and fold the dough.</p>
                <p>Let the dough rest again for 20 minutes, then fold it in a spiral, and then fold it again 20 minutes later.</p>
                <p><strong className="text-white">Total rising time:</strong> 3 to 4 hours from the end of kneading to shaping.</p>
                <p><strong className="text-white">Shaping:</strong> Divide the dough into 700-720g portions, then shape into bâtard loaves.</p>
                <p><strong className="text-white">Proofing in a banneton:</strong> 2 to 3 hours at room temperature.</p>
              </div>
            </div>

            <div className="bg-white/5 border border-white/10 rounded-xl p-5">
              <h4 className="text-lg font-semibold mb-3 text-amber-400">Baking</h4>
              <ul className="space-y-2 text-white/90">
                <li>• 35 minutes at 240°C (465°F) for a conventional oven</li>
                <li>• For baking in a Dutch oven: 20 minutes with the lid on, then 15 minutes uncovered</li>
              </ul>
            </div>
          </div>

          <button
            onClick={onClose}
            className="w-full mt-6 py-3 bg-amber-600 hover:bg-amber-700 text-white rounded-xl font-semibold transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
